import Vue from 'vue'

import VueTheMask, { TheMask } from 'vue-the-mask'
import Notifications from 'vue-notification'
import VueFileAgent from 'vue-file-agent'
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css'
import BlockUI from 'vue-blockui'

import axios from 'axios'

import i18n from './plugins/i18n'
import { store } from './plugins/store'
import globals from './plugins/globals'

import './components'

const core = {
  carregaEmpresa: false,
  carregaEnum: true,
  apiBMPDigitalCore: false,
  useOIDCAuth: false,
  initialRoute: '/dashboard',
  store: store,
  api: {}
}

core.methods = {
  init: function (controllers) {
    store.commit('apiBMPDigitalCore', core.apiBMPDigitalCore)
    store.commit('useOIDCAuth', core.useOIDCAuth)
    store.commit('initialRoute', core.initialRoute)
    core.api = require('./api').default
    core.api.init(controllers)

    Vue.config.productionTip = false
    Vue.prototype.$api = core.api
    Vue.prototype.$store = store
    Vue.prototype.global = {
      GuidEmpty: '00000000-0000-0000-0000-000000000000'
    }

    Vue.use(VueTheMask)
    Vue.component(TheMask)
    Vue.use(Notifications)
    Vue.use(VueFileAgent)
    Vue.use(VueFileAgentStyles)
    Vue.use(BlockUI)

    Vue.mixin({
      data: globals,
      computed: {
        $user: {
          get () {
            return core.store.getters.user
          }
        } 
      }
    })

    axios.get('/version.json').then(function (data) {
      const version = localStorage.getItem('appVersion')
      if (version !== data.data.version) {
        localStorage.setItem('appVersion', data.data.version)
        location.reload()
      }
    })

     // ver se o oidc já grava o token, incluir role administrador no usuário
     if (core.useOIDCAuth) {
      const Mgr = require('./plugins/security/oidc-service').default
      let mgr = new Mgr()
      Vue.prototype.$mgr = mgr

      mgr.getSignedIn().then(
        signIn => {
          if(!signIn)
          core.carregaEnum = false
          getEnum()
        },
        err => {
          console.log(err)
        }
      )
    }
    else
      getEnum()
  },
  version: function () {
    axios.get('/version.json').then(function (data) {
      const version = localStorage.getItem('appVersion')
      if (version !== data.data.version) {
        localStorage.setItem('appVersion', data.data.version)
        location.reload()
      }
    })
  },
  finish(paths, theme, App) {
    if (!theme.options.drawer) {
      theme.options.drawer = {}
    }
    if (!theme.options.compact) {
      theme.options.compact = {}
    }
    if (!theme.options.grid) {
      theme.options.grid = { pageSize: [5, 10, 15, 20, -1] }
    }
    store.commit('paths', paths)
    store.commit('theme', theme)
    const vuetify = require('./plugins/vuetify').default
    var router = null
    if (core.useOIDCAuth) {
      const Mgr = require('./plugins/security/oidc-service').default
      Vue.prototype.$mgr = new Mgr()
      router = require('./plugins/oidc-router').default
    } else
      router = require('./plugins/router').default

    new Vue({
      i18n,
      router,
      vuetify,
      axios,
      render: h => h(App),
      created() {
        if (!core.useOIDCAuth) {
          const userString = localStorage.getItem('user')
          if (userString) {
            const userData = JSON.parse(userString)
            this.$store.commit('SET_USER_DATA', { user: userData, empresa: this.$empresa })
          }
        }
      }
    }).$mount('#app')
  }
}
export default core

function getEnum()
{
  if (core.carregaEnum) {
    // Carregar Arrays e Enums
    core.api.Enum.GetAll().then(function (response) {
      var items = Object.keys(response)
      core.api.Enums = {}
      core.api.Arrays = {}
      items.forEach(function (p) {
        core.api.Enums[p] = {}
        response[p].forEach(function (o) { core.api.Enums[p][o.name] = o.value })
  
        core.api.Arrays[p] = []
        response[p].forEach(function (o) { core.api.Arrays[p].push({ value: o.value, text: o.description, name: o.name }) })
      })
      getEmpresa()
    })
  } else {
    getEmpresa()
  }
}
function getEmpresa() {
  // Carregar Variáveis de ambiente, thema
  const empresa = localStorage.getItem('empresa')
  if (empresa) {
    Vue.prototype.$empresa = JSON.parse(empresa)
  } else {
    let dataEmpresa = {
      placeholder: ' ',
      placeholderSelect: 'Selecione',
      placeholderMultiSelect: 'Nenhum',
      placeholderCombobox: 'Digite ou Selecione',
      placeholderMultiCombobox: 'Nenhum',
      outlined: true,
      dense: true
    }

    if (core.carregaEmpresa) {
      core.api.Empresa.GetCustomJSON(Vue.prototype.global.GuidEmpty).then(function (response) {
        if (core.api.UI.PostLoadData(response)) {
          dataEmpresa = Object.assign(dataEmpresa, response)
          Vue.prototype.$empresa = dataEmpresa
          store.commit('empresa', dataEmpresa)
        }
      })
    } else {
      Vue.prototype.$empresa = dataEmpresa
      store.commit('empresa', dataEmpresa)
    }
  }
}

